// @ts-nocheck
import {
    searchFieldWrapperStyles,
    SearchFieldWrapperStyles,
} from "@insite/content-library/Widgets/OrderHistory/SearchFieldWrapper";
import { css } from "styled-components";

Object.assign<SearchFieldWrapperStyles>(searchFieldWrapperStyles, {
    wrapper: {
        css: css`
            width: 100%;
        `,
    },
});
